import { OIDBalanceSuccessorBorrowerDetails } from './OIDBalanceSuccessorBorrowerDetails';

export default OIDBalanceSuccessorBorrowerDetails;
